/**  @jsx jsx */
import { jsx } from 'theme-ui';
import { graphql } from 'gatsby';
import ProductListPage from '../components/ProductListPage';

export default function ProductListTemplate({
  data: { productList, next, previous, exhibitor },
  pageContext,
}) {
  return (
    <ProductListPage
      productList={productList}
      next={next}
      previous={previous}
      producer={exhibitor}
      products={productList && productList.products}
      {...pageContext}
    />
  );
}

export const pageQuery = graphql`
  query($id: String!, $nextId: String, $previousId: String) {
    ...ProductListPage_Query
    productList: event(id: { eq: $id }) {
      ...ProductListPage
    }
    next: event(id: { eq: $nextId }) {
      ...ProductListPage_ChangeLink
    }
    previous: event(id: { eq: $previousId }) {
      ...ProductListPage_ChangeLink
    }
  }
`;
